/* eslint-disable max-len */
/* eslint-disable no-console */
import { Box, Tooltip, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { IoChatboxEllipses, IoChatboxOutline } from 'react-icons/io5';
import { feedActionContext } from '../../../..';
import { LanguageContext } from '../../../../../../libs/Context';
import useGetFeedPermissions from '../../../CustomHooks/useGetFeedPermissions';
import { useSelector } from 'react-redux';
import { feedActionContextFromExternal } from '../../../ExternalRequest';

const CommentButton = (props) =>
{
	const { feed } = props;
	const { language } = useContext(LanguageContext);
	const { feedCardActn, feedAction, setFeedCardActn, handleFeedAction } = useContext(window.location.pathname.includes('news') ? feedActionContext : feedActionContextFromExternal);
	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions(feed, userData);
	const hasCommentPermission = getPermission('comments');

	if (!getPermission('comments')) return <></>;

	const commentCnt =
	feedCardActn?.[1]?._id === feed?._id && feedAction?.comments_add
		? feedAction?.comments_add
		: feed?.commentsCount;

	const toggleComments = () =>
	{
		if (feedCardActn?.[1]?._id === feed?._id)
		{
			handleFeedAction('remove', 'comments_add');
			setFeedCardActn([]);
		}
		else
		{
			handleFeedAction('append', 'comments_add', commentCnt);
			setFeedCardActn([ 'comments', feed ]);
		}
	};

	return (
		<Box display='flex' alignItems='center'
			sx={{
				cursor        : !hasCommentPermission ? '' : 'pointer',
				pointerEvents : !hasCommentPermission ? 'none' : '',
				opacity       : !hasCommentPermission ? 0.5 : ''
			}}
			// sx={{ cursor: 'pointer' }}
			onClick={toggleComments}
		>
			<Tooltip title={language.comment} placement='top'>
				<Box
					sx={{ marginRight   : 0.5,
						color         : 'var(--greyColor)',
						'&:hover svg' : {
							backgroundColor : 'transparent',
							color           : 'var(--blueColor)', // Hover color
							transform       : 'scale(1.2)' // Hover scale
						}
					}}
					display={'flex'}
				>
					{(Array.isArray(feedCardActn) && feedCardActn?.length > 0 &&
					feedCardActn[0] === 'comments' && feedCardActn[1]?._id === feed?._id)
						? (
							<IoChatboxEllipses style={{ fontSize: 'var(--pixel20)', color: 'var(--primaryColor)' }} />

						)
						: (<IoChatboxOutline fontSize={'var(--pixel20)'} />)}
				</Box>
			</Tooltip>
			{/* {commentCnt !== 0 && */}
			<Box width={'24px'} ml={0.2} display={'flex'} height={'18px'} justifyContent={'center'} alignItems={'center'} borderRadius={'8px'} bgcolor={'#d9f5fb'}>
				<Typography variant='caption' fontWeight='var(--font500)' color='var(--greyColor)'>
					{Number.isInteger(commentCnt) && commentCnt > 0 ? commentCnt : 0}
				</Typography>
			</Box>
			{/* } */}
		</Box>
	);
};

export default CommentButton;